import { useMapStore } from '../../state/mapStore';
import { useViewMode } from '../../state/viewMode';
import { useBim } from '../bim/bimStore';
import { OverlayPopup } from './OverlayPopup';
import { CONTROLLER_TOOLS } from './registry';

/**
 * The Map tools controller (top right): one round button per tool, in production order; one pane open at a time. It
 * also hosts the popup of the layers the tools draw (OverlayPopup), which outlives any one pane: Data Passport's
 * imports stay on the map with its pane closed.
 */
export function MapToolsController({
  openTool,
  onToggle,
}: {
  openTool: string | null;
  onToggle: (id: string) => void;
}) {
  // Geology's button only where it can draw: in BIM, on a model whose structures name one.
  const inBim = useViewMode((s) => s.mode === 'bim');
  const hasGeology = useBim((s) => s.geologyAvailable);
  // A project's widgetsOff leaves a tool off its controller (a switch, not a build without it).
  const off = useMapStore((s) => s.config?.project.widgetsOff);
  const tools = CONTROLLER_TOOLS.filter((t) => (t.id !== 'geology' || (inBim && hasGeology)) && !off?.includes(t.id));
  return (
    <>
      <nav className={openTool ? 'mm-controller has-active' : 'mm-controller'} aria-label="Map tools">
        <ul>
          {tools.map((tool) => {
            const active = tool.id === openTool;
            return (
              <li key={tool.id} className={active ? 'mm-avatar active' : 'mm-avatar'}>
                <button
                  type="button"
                  className="mm-avatar-btn"
                  title={tool.label}
                  aria-label={tool.label}
                  aria-pressed={active}
                  data-tool={tool.id}
                  onClick={() => onToggle(tool.id)}
                  dangerouslySetInnerHTML={{ __html: tool.icon }}
                />
              </li>
            );
          })}
        </ul>
      </nav>
      <OverlayPopup />
    </>
  );
}
